import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <h1 className="text-xl md:text-2xl font-bold text-blue-700 break-words">
              {contactInfo.brandName}
            </h1>
            <span className="text-xs md:text-sm text-gray-600 break-words">
              {contactInfo.domain}
            </span>
          </div>
          
          <div className="flex gap-2">
            <a
              href="https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20intervento%20a%20Roma.%20Potete%20intervenire%20oggi?"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-500 hover:bg-orange-600 text-white flex items-center gap-1 md:gap-2 px-4 md:px-8 py-2 md:py-3 text-sm md:text-base font-semibold transition-all duration-300 hover:scale-105 rounded-md"
            >
              <MessageCircle className="h-4 w-4 md:h-5 md:w-5" />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>
            
            <a
              href={`tel:${contactInfo.phone}`}
              className="bg-blue-700 hover:bg-blue-800 text-white flex items-center gap-1 md:gap-2 px-3 md:px-5 py-2 md:py-3 text-sm md:text-base transition-all duration-300 hover:scale-105 rounded-md"
            >
              <Phone className="h-4 w-4 md:h-5 md:w-5" />
              <span className="hidden sm:inline">Chiama</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
